// eslint-disable-next-line import/default
import mapboxgl from 'mapbox-gl';

// TODO-20231123: This is temporary solution, we have to improve this. We require SMG Mapbbox account token.
mapboxgl.accessToken =
  'pk.eyJ1Ijoic21nLW1hcCIsImEiOiJjbHJxODd6eGcwMGVjMmluY2UyNndveHA4In0.JbycFA8mSKtk69TMMD__zg';

export const CANTONTILESETID = 'mapbox://smg-map.MarketAtlasCantons';
export const MUNICIPALITYTILESETID = 'mapbox://smg-map.MarketAtlasMunicipalities';
export const TOWNTILESETID = 'mapbox://smg-map.MarketAtlasTowns';

export const OPACITY_MAX = 1;
export const LINECOLOR_SELECTED = '#000000';
export const LINECOLOR_HOVER = '#3FFFC9';
export const FALLBACKCOLOR = '#C8C8C8';
export const FILLOUTLINECOLOR = 'black';
export const FILL_OPACITY = 'fill-opacity';
export const MAP_MAX_ZOOM = 17.5;
export const MAP_MIN_ZOOM = 6;
export const MAP_LARGE_SCREEN_ZOOM = 6.8;

export const YAXISMINVALUE = -5;
export const YAXISMAXVALUE = 5;
export const STEPSIZEMINLIMIT = 5;
export const STEPSIZEMINVALUE = 1;
export const TICKAMOUNTMINLIMIT = 5;
export const XAXISMAXTICKS = 11;

export const CANTON_MIN_ZOOM_DESKTOP = 0;
export const CANTON_MAX_ZOOM_DESKTOP = 9;
export const MUNICIPALITY_MIN_ZOOM_DESKTOP = 9.01;
export const MUNICIPALITY_MAX_ZOOM_DESKTOP = 11;
export const TOWN_MIN_ZOOM_DESKTOP = 11.01;
export const ZIPTOWN_MIN_ZOOM_DESKTOP = 13.01;
export const TOWN_MAX_ZOOM_DESKTOP = 22;
export const CANTON_MIN_ZOOM_MOBILE = 0;
export const CANTON_MAX_ZOOM_MOBILE = 8;
export const MUNICIPALITY_MIN_ZOOM_MOBILE = 8.01;
export const MUNICIPALITY_MAX_ZOOM_MOBILE = 10;
export const TOWN_MIN_ZOOM_MOBILE = 10.01;
export const ZIPTOWN_MIN_ZOOM_MOBILE = 12.01;
export const TOWN_MAX_ZOOM_MOBILE = 22;
export const DEFAULT_MIN_ZOOM = 0;
export const DEFAULT_MAX_ZOOM = 22;
export const SWITZERLAND_COORDINATE: [number, number] = [8.0320498, 46.8155364];
